import React from 'react'
import {
  Box,
  Typography,
  Button,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
      }}
    >
      <Box
        sx={{
          maxWidth: '800px',
          textAlign: 'center',
        }}
      >
        <Typography
          sx={{
            color: '#57C84D',
            fontSize: {
              xs: '5rem',
              md: '8rem',
            },
            fontWeight: 700,
            lineHeight: 1,
            mb: 2,
          }}
        >
          404
        </Typography>

        <Typography
          variant="h3"
          sx={{
            color: '#fff',
            fontWeight: 700,
            mb: 3,
          }}
        >
          Looks Like This Pallet Is Missing
        </Typography>

        <Typography
          sx={{
            color: '#d7e3dd',
            fontSize: '1.1rem',
            lineHeight: 1.8,
            maxWidth: '600px',
            mx: 'auto',
            mb: 5,
          }}
        >
          The page you're looking for may have been moved,
          removed or never existed in the first place.
          Let's get you back on track.
        </Typography>

        <Button
          size="large"
          onClick={() => navigate('/')}
          sx={{
            backgroundColor: '#0A9B48',
            color: '#fff',
            minWidth: '220px',
            py: 2,
            px: 4,
            fontSize: '1rem',
            fontWeight: 700,
            letterSpacing: '1px',
            borderRadius: 0,

            '&:hover': {
              transform: 'translateY(-5px)',
              borderColor: 'white',
              border: '1px solid',
              boxShadow: '0 10px 30px rgba(87,200,77,0.15)',
              backgroundColor: '#57C84D'
            }
          }}
        >
          RETURN HOME →
        </Button>
      </Box>
    </Box>
  )
}

export default NotFoundPage